import angular from 'angular';

const mfHighlightFilter = ($sce, $injector, $log) => {
	const isSanitizePresent = $injector.has('$sanitize');

	// Regex: capture the whole query string and replace it with the string that will be used to match
	// the results, for example if the capture is "a" the result will be \a
	// eslint-disable-next-line unicorn/consistent-function-scoping
	const escapeRegexp = queryToEscape => queryToEscape.replace(/([$()*+.?[\\\]^{|}-])/g, '\\$1');
	// eslint-disable-next-line unicorn/consistent-function-scoping
	const containsHtml = matchItem => /<.*>/g.test(matchItem);

	return (_matchItem, query) => {
		if (!isSanitizePresent && containsHtml(_matchItem)) {
			$log.warn('Unsafe use of MF please use ngSanitize'); // Warn the user about the danger
		}

		// Replaces the capture string with a the same string inside of a "strong" tag
		let matchItem = query ?
			(`${_matchItem}`).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : _matchItem;

		// If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
		if (!isSanitizePresent) {
			matchItem = $sce.trustAsHtml(matchItem);
		}

		return matchItem;
	};
};

export default angular
	.module('app')
	.filter('mfHighlight', /* @ngInject */ mfHighlightFilter)
	.name;
